import Vue from 'vue'
import Vuex from 'vuex'

const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    isLoggedIn: localStorage.getItem('token'),
    userName: localStorage.getItem('username'),
    userId: localStorage.getItem('userId'),
    boxed: localStorage.getItem('boxed'),
    fullscreen: localStorage.getItem('fullscreen'),
    isSidebarFull: localStorage.getItem('sidebarFull'),
    acl: localStorage.getItem('acl'),
    accountAgencies: localStorage.getItem('accountAgencies'),
    notifications: {
      list: [],
      last_notification_id: null
    }
  },
  mutations: {
    [LOGIN] (state) {
      state.pending = true
    },
    [LOGIN_SUCCESS] (state) {
      state.isLoggedIn = true
      state.pending = false
      state.userName = localStorage.getItem('username')
      state.acl = localStorage.getItem('acl')
      state.accountAgencies = localStorage.getItem('accountAgencies')
    },
    [LOGOUT] (state) {
      localStorage.removeItem('username')
      state.isLoggedIn = false
      state.userName = false
      state.acl = {}
      state.accountAgencies = []
    },
    'boxProcess' (state) {
      state.boxed = localStorage.getItem('boxed')
      state.fullscreen = localStorage.getItem('fullscreen')
    },
    'm_toggleSidebar' (state) {
      let toggleSidebar = localStorage.getItem('sidebarFull')
      if (toggleSidebar) {
        localStorage.removeItem('sidebarFull')
        state.isSidebarFull = false
      } else {
        localStorage.setItem('sidebarFull', true)
        state.isSidebarFull = true
      }
    },

    'SET_NOTIFICATIONS' (state, notifications) {
      state.notifications = notifications
    }
  },
  actions: {
    login ({
      state,
      commit,
      rootState
    }, data) {
      commit(LOGIN) // show spinner
      localStorage.setItem('token', data.token)
      localStorage.setItem('username', data.displayName)
      localStorage.setItem('userId', data.id)
      localStorage.setItem('acl', JSON.stringify(data.acl))
      localStorage.setItem('accountAgencies', JSON.stringify(data.accountAgencies))
      return this.dispatch('setAuthHeader').then(() => {
        document.body.classList.remove('login-container')
        document.body.classList.add('navbar-top')
        commit(LOGIN_SUCCESS)
      })
    },

    logout ({
      commit
    }) {
      return new Promise((resolve, reject) => {
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        localStorage.removeItem('userId')
        localStorage.removeItem('acl')
        localStorage.removeItem('accountAgencies')
        document.body.classList.add('login-container')
        document.body.classList.remove('navbar-top')
        commit(LOGOUT)
        resolve()
      })
    },

    isLogged ({
      commit
    }) {
      if (!localStorage.getItem('token')) {
        commit(LOGOUT)
      }

      return this.state.isLoggedIn
    },

    checkAuth () {
      if (this.state.isLoggedIn) {
        return this.dispatch('setAuthHeader')
      }
    },

    toggleSidebar ({
      commit
    }) {
      commit('m_toggleSidebar')
    },

    setAuthHeader () {
      return this.dispatch('getAuthHeader').then(headers => {
        Vue.http.headers.common = headers
      })
    },

    getAuthHeader () {
      return {
        'Authorization': 'Bearer ' + localStorage.getItem('token')
      }
    },

    setBoxed ({
      commit
    }) {
      console.log('boxed')
      localStorage.setItem('boxed', true)
      localStorage.setItem('fullscreen', false)
      commit('boxProcess')
    },

    setUnboxed ({
      commit
    }) {
      console.log('unboxed')
      localStorage.setItem('boxed', false)
      localStorage.setItem('fullscreen', false)
      commit('boxProcess')
    },

    setFullscreen ({
      commit
    }) {
      localStorage.setItem('fullscreen', true)
      localStorage.setItem('boxed', false)
      commit('boxProcess')
    },

    setNotifications ({
      commit, state
    }, notifications) {
      commit('SET_NOTIFICATIONS', notifications)
      return state
    }
  },
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn
    },

    isAdmin: state => {
      return state.isAdmin
    },

    userName: state => {
      return state.userName
    },

    userId: state => {
      return state.userId
    },

    boxed: state => {
      console.log('GetBoxed: ', state.boxed)
      return state.boxed
    },

    fullscreen: state => {
      return state.fullscreen === 'true'
    },

    isSidebarFull: state => {
      return state.isSidebarFull
    },

    acl: state => {
      return state.acl
    },

    accountAgencies: state => {
      return state.accountAgencies
    },

    notifications: state => {
      return state.notifications
    }
  }
})

export default store
